export const SeverityLevels = [
  "Low",
  "Medium",
  "High"
]